// A dónde le pega el front (API y socket), SIN depender del dominio.
//
// 11/10/2026: el CRM pasó de bot.posberry.com a crm.posberry.com y en crm el
// build de prod pegaba a http://localhost:5002: `.env.local` (commiteado) pisa
// a `.env.production` en Create React App, y bot sólo andaba porque su
// hostname estaba hardcodeado acá y en SocketContext. Regla única: en prod
// todo es mismo origen (nginx proxya /api y /socket.io en cualquier dominio
// del server); la env var sólo vale en desarrollo local, donde el dev server
// de CRA no proxya la API.

const LOCALES = new Set(['localhost', '127.0.0.1', '[::1]']);

export const esDesarrolloLocal = (hostname) => LOCALES.has(hostname) || hostname.endsWith('.localhost');

/** Base de axios: '' (relativo) en prod; la env var sólo en local. */
export function resolverApiUrl(hostname, origin, envUrl) {
  if (esDesarrolloLocal(hostname) && envUrl) return envUrl;
  return '';
}

/** URL del socket: el origen de la página en prod; la env var sólo en local. */
export function resolverSocketUrl(hostname, origin, envUrl) {
  if (esDesarrolloLocal(hostname) && envUrl) return envUrl;
  return origin;
}
